<template>
<div class="limiter">
  <div class="container-login">
    <v-container fluid>
    
      <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="8" lg="8">
          <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
            <span class="login-title">
              <img src="../../assets/lages.jpeg" width="250px">
            </span>
            <v-card-text style="padding: 0px">
              <v-container fluid grid-list-md>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm12 lg12>
                    <p style="margin-bottom: 0px;">Selecione o culto que você deseja participar:</p>
                  </v-flex>
                  <v-flex xs12 sm12 lg12>
                    <v-select outlined dense v-model="inscricao.eventoId" :items="eventos" item-text="nome" item-value="id" color="#00695C"></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 lg12>
                    <p style="margin-bottom: 0px;">Preencha seus dados:</p>
                  </v-flex>
                  <v-flex xs12 sm12 lg8>
                    <v-text-field light v-model="inscricao.nome" label="NOME COMPLETO" single-line outlined color="#00695C" dense hide-details required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field light label="CPF" color="#00695C" outlined v-mask="mask" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="inscricao.cpf"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-select outlined dense v-model="inscricao.tipo" :items="tipo" hide-details item-text="titulo" item-value="id" color="#00695C" label="TIPO DE INSCRIÇÃO"></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-select outlined dense v-model="inscricao.sexo" :items="sexo" hide-details item-text="titulo" item-value="id" color="#00695C" label="SEXO"></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field light label="TELEFONE" color="#00695C" type="tel" outlined hide-details v-mask="'(##) #####-####'" dense required v-model="inscricao.telefone"></v-text-field>
                  </v-flex>
                  <v-flex xs10 sm10 lg6>

                  </v-flex>
                  <!-- <v-flex xs10 sm10 lg12>
                <qrcode-vue :value="'12456'" :size="size" level="H"></qrcode-vue>
                </v-flex> -->
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions style="padding: 0px">
              <v-container fluid grid-list-md>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm12 lg8>
                    <v-btn dark depressed block color="#7b4f44" style="border-radius: 7px;" large @click="realizarInscricao">Confirmar Inscrição</v-btn>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-btn dark depressed block color="#E53935" style="border-radius: 7px;" large @click="solicitaCancelamento">Solicitar Cancelamento</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <br>
      <div class="login-title">
        <a href="https://www.intelitetecnologia.com.br/" target="_blank">
          <img src="../../assets/logo.webp" width="130px">
        </a>

      </div>

      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card style="border-radius: 10px;">
          <v-card-title style="justify-content: center; padding: 8px;">
            <span class="texto">{{NomeEmpresa}}</span>
          </v-card-title>
          <v-card-text style="text-align: center;padding:0 24px 0;">
            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <p class="texto">{{msgResultado}}</p>
                </v-col>
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <p class="texto" style="color:#00695C">{{inscricao.nome}}</p>
                </v-col>                
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <p class="texto" style="color:#EF6C00">Guarde esse código ou print essa imagem, será necessário para a sua identificação no dia do culto.</p>
                </v-col>
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <p class="texto">{{cultoSelecionado}}</p>
                </v-col>
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <p class="texto" style="background-color: #D32F2F;color: white;">O uso de máscara é obrigatório.</p>
                </v-col>
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <p class="texto">SEU CÓDIGO É: <span style="color:#EF6C00">{{inscricao.cod_incricao}}</span></p>
                </v-col>
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <qrcode-vue :value="inscricao.cod_incricao" :size="100" level="H"></qrcode-vue>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="border-radius: 7px;" dark depressed block color="#00695C" @click="closeDialog">fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogCancelamento" persistent max-width="600px">
        <v-card style="border-radius: 10px;">
          <v-card-title style="justify-content: center; padding: 8px;">
            <span class="texto">Solicitação de Cancelamento</span>
          </v-card-title>
          <v-card-text style="text-align: center;padding:0 24px 0;">
            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <p class="texto" style="color:#00695C">{{inscricao.nome}}</p>
                </v-col>
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <p class="texto" style="color:#00695C">CPF : {{inscricao.cpf}}</p>
                </v-col>
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <p class="texto">{{cultoSelecionado}}</p>
                </v-col>
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <p class="texto" style="background-color: #D32F2F;color: white;">Confirme a sua solicitação de cancelamento</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="border-radius: 7px;" dark depressed block color="#00695C" @click="realizarCancelamento">confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </div>
  <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage">
  </loading>
  <Snackbar ref=chamaSnackbar />
</div>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import CpfValidate from '../../componentes/validators/rules/cpf'
import QrcodeVue from 'qrcode.vue'
import {
  baseApiUrl
} from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import {
  mapState
} from 'vuex'
import moment from 'moment'
import axios from 'axios'
export default {
  components: {
    Snackbar,
    QrcodeVue,
    Loading
  },
  name: 'Auth',
  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
  }),
  data: function () {
    return {
      mask: "###.###.###-##",
      user: {},
      NomeEmpresa: '',
      cultoSelecionado: '',
      inscricao: {
        cod_incricao: '',
        nome: '',
        cpf: '',
        tipo: '',
        sexo: '',
        telefone: '',
        eventoId: ''
      },
      inscricaoDefault: {
        cod_incricao: '',
        nome: '',
        cpf: '',
        tipo: '',
        sexo: '',
        telefone: '',
        eventoId: ''
      },
      dialogCancelamento: false,
      dialog: false,
      qtdInscritos: 0,
      capacidadeEvento: 0,
      reserva: 0,
      sexo: ['MASCULINO', 'FEMININO'],
      tipo: ['MEMBRO', 'VISITANTE'],
      eventos: [],
      isLoading: false,
      fullPage: true,
      jaExiste: false,
      codigoExistente: '',
      msgResultado: '',
      idInscricao: ''
    }
  },
  mounted: function () {
    this.carregaDados()
    this.$validator.localize('pt', this.dictionary)

  },
  methods: {
    async carregaDados() {
      this.isLoading = true
      await axios.get(`${baseApiUrl}Eventos?filter={"where":{"and":[{"empresaId":"60539149ef3be404002074f7"},{"ativo":"true"}]}}`)
        .then(res => {
          for (var key in res.data) {
            if (res.data.hasOwnProperty(key)) {

              if (moment(this.formatDateHora(res.data[key].fim), 'DD/MM/YYYY HH:mm:ss', true).format() >= moment().format())
              /* if(res.data[key].ativo == true) */
              {
                this.eventos.push(res.data[key])
                this.eventoId = res.data[key].id
              }

            }
          }
          this.eventos = this.eventos.sort(this.compare)
          this.isLoading = false
        })

        try {
          let res = await axios.get(`${baseApiUrl}Empresas/60539149ef3be404002074f7?access_token=HKTGrGOByIHlt2fDNQQCa59k2CkzaLM1rEHqs1G9ltCnxT5bPfSL1M7C73Bm3yGt`)
          this.NomeEmpresa = res.data.nome
        } catch (error) {
          //
        }
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDatePadrao(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDateBrz(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHora(date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

    async solicitaCancelamento() {
      this.isLoading = true
      if (this.inscricao.nome == '' || this.inscricao.eventoId == '' || this.inscricao.cpf == '') {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha os campos: Culto, Nome e CPF para solicitar o cancelamento!", "ATENÇÃO")
      } else {
        this.isLoading = false
        this.dialogCancelamento = true
      }
    },

    async realizarCancelamento() {
      this.idInscricao = ''
      this.isLoading = true
      try {
        let res = await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.inscricao.eventoId}"},{"cpf":"${this.inscricao.cpf}"}]}}`)

        if (res.data[0].id) {
          this.idInscricao = res.data[0].id

        } else {
          this.isLoading = false
          this.dialogCancelamento = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível localizar a inscrição, verifique os dados e tente novamente!", "ATENÇÃO")
        }

      } catch (error) {

        this.isLoading = false
        this.dialogCancelamento = false
        vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível localizar a inscrição, verifique os dados e tente novamente!", "ATENÇÃO")

      }
      if (this.idInscricao != '') {

        try {
          let res = await axios.delete(`${baseApiUrl}Inscricoes/${this.idInscricao}`)
          if (res.data != '') {
            this.isLoading = false
            this.inscricao = Object.assign({}, this.inscricaoDefault)
            this.dialogCancelamento = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1", "Cancelamento realizado com sucesso!", "INFORMAÇÃO")

          } else {
            this.isLoading = false
            this.dialogCancelamento = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!", "ATENÇÃO")
          }
        } catch (error) {
          this.isLoading = false
          this.dialogCancelamento = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!", "ATENÇÃO")

        }
      }

    },

    async realizarInscricao() {
      await this.carregaDados()
      this.isLoading = true
      this.jaExiste = false
      if (this.inscricao.nome == '' || this.inscricao.eventoId == '' || this.inscricao.cpf == '' || this.inscricao.tipo == '' || this.inscricao.sexo == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf)) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
      } else {

        for (var key in this.eventos) {
          if (this.eventos.hasOwnProperty(key)) {
            if (this.eventos[key].id == this.inscricao.eventoId) {
              this.capacidadeEvento = this.eventos[key].vagas
              this.cultoSelecionado = this.eventos[key].nome
              this.reserva = this.eventos[key].reserva
            }

          }
        }

        await axios.get(`${baseApiUrl}Inscricoes?filter[where][eventoId]=${this.inscricao.eventoId}`)
          .then(res => {
            this.qtdInscritos = res.data.length + this.reserva
            if (res.data.length > 0) {
              for (var j = 0; j <= res.data.length - 1; j++) {

                if (res.data[j].cpf == this.inscricao.cpf) {
                  this.jaExiste = true
                  this.insricaoExistente = res.data[j]
                  this.codigoExistente = res.data[j].cod_incricao
                }
              }
            }
          })
        if (this.jaExiste) {
          this.msgResultado = 'Já existe um cadastro realizado para esse culto com o CPF informado'
          this.isLoading = false
          this.inscricao.cod_incricao = this.codigoExistente
          this.dialog = true
        } else
        if (this.qtdInscritos == this.capacidadeEvento && !this.jaExiste) {
          this.isLoading = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, a capacidade máxima para o culto selecionado foi atingida!", "INFORMAÇÃO")
        } else {
          this.inscricao.cod_incricao = new Date().getTime().toString().substr(8, 12)
          await axios.post(`${baseApiUrl}Inscricoes/replaceOrCreate`, this.inscricao)
            .then(() => {
              this.isLoading = false
              this.msgResultado = 'Cadastro realizado com sucesso!'
              this.dialog = true
              this.carregaDados()

            }).catch(() => {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar cadastro, tente novamente", "ERRO")
            })
        }

      }
    },

    closeDialog() {
      this.dialog = false
      this.inscricao = Object.assign({}, this.inscricaoDefault)
      this.$validator.reset()
    },
    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.fim;
      const dataB = b.fim;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },
  }
}
</script>

<style scoped>
/* LOGIN */

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(to right, #b44302e1, #c59588d0);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 15px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 15px;
  padding-bottom: 15px;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center
}
</style>
